module.exports = __webpack_public_path__ + "img/wollust.52b300dc.png";